import React from "react";
import { useSelector } from "react-redux";
import { checkForOverride, glow, linearGradient } from "../helpers/theme";
import {
	ReplaceWithDataSource,
	replaceWithDataSource,
} from "../helpers/variable";

export default function Social({
	cue,
	baseTheme,
	baseThemeId,
	dynamicLists,
	dynamicText,
	mediaLocation,
}) {
	const settings = useSelector((state) => state.main.settings);
	return (
		<>
			<div className="flex items-center">
				<div
					className={`${baseThemeId}_${cue.type}_profile_image profile_image
        ${
					baseTheme?.["social"]?.image_shape === "rounded" &&
					`rounded-${checkForOverride(
						baseTheme,
						"social",
						cue.preset,
						"background",
						"rounding"
					)}`
				}
        
        
        
        `}
					style={{
						backgroundImage: `url(${
							cue.useCustomImage
								? `${mediaLocation}${cue.customImage}`
								: cue.chat?.authorDetails?.profileImageUrl
						})`,
						backgroundRepeat: "no-repeat",
						backgroundSize: "cover",
						backgroundPosition: "center",
						width: cue.chat?.authorDetails?.profileImageUrl ? "9vw" : "0vw",
						height: "9vw",
						minWidth: cue.chat?.authorDetails?.profileImageUrl ? "9vw" : "0vw",
						minHeight: "9vw",
						display: "table",
						borderRadius:
							(!baseTheme?.["social"]?.image_shape ||
								baseTheme?.["social"]?.image_shape === "circle") &&
							"100%",
						// filter: "contrast(70%)",
					}}
				>
					{/* PLATFORM IMAGE OR NAME */}
					{cue.chat?.platform && (
						<div
							className={`bg-cover bg-center rounded-full mr-2 absolute -bottom-2 -left-2`}
							style={{
								backgroundImage: `url(${cue.chat?.platform?.logoUrl})`,
								width: "4vw",
								height: "4vw",
								minWidth: "4vw",
								minHeight: "4vw",
							}}
						></div>
					)}
				</div>
				<div
					className={`flex flex-col items-start
                    pl-s2
    `}
				>
					<span
						style={{
							background: linearGradient(
								baseTheme,
								cue.type,
								cue.preset,
								"background",
								"colour"
							),
							boxShadow: glow(
								baseTheme,
								cue.type,
								cue.preset,
								"background",
								"glowBlur"
							),
							minWidth:
								replaceWithDataSource(
									cue.chat?.snippet?.displayMessage,
									dynamicText,
									dynamicLists
								)?.length < 60 && "max-content",
							borderTop: `${
								checkForOverride(
									baseTheme,
									cue.type,
									cue.preset,
									"border",
									"sides"
								)[0] === "1"
									? baseTheme.border.size
									: 0
							}vw ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"style"
							)} ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"colour"
							)}`,
							borderBottom: `${
								checkForOverride(
									baseTheme,
									cue.type,
									cue.preset,
									"border",
									"sides"
								)[1] === "1"
									? baseTheme.border.size
									: 0
							}vw ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"style"
							)} ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"colour"
							)}`,
							borderLeft: `${
								checkForOverride(
									baseTheme,
									cue.type,
									cue.preset,
									"border",
									"sides"
								)[2] === "1"
									? baseTheme.border.size
									: 0
							}vw ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"style"
							)} ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"colour"
							)}`,
							borderRight: `${
								checkForOverride(
									baseTheme,
									cue.type,
									cue.preset,
									"border",
									"sides"
								)[3] === "1"
									? baseTheme.border.size
									: 0
							}vw ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"style"
							)} ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"colour"
							)}`,
						}}
						className={`${baseThemeId}_${cue.type} social ${
							cue.type
						}  px-s1 py-s1 rounded-${checkForOverride(
							baseTheme,
							"social",
							cue.preset,
							"background",
							"rounding"
						)} rounded-tr-${checkForOverride(
							baseTheme,
							"social",
							cue.preset,
							"background",
							"rounding"
						)}
        
            px-${checkForOverride(
							baseTheme,
							"social",
							cue.preset,
							"background",
							"paddingX"
						)}
            py-${checkForOverride(
							baseTheme,
							"social",
							cue.preset,
							"background",
							"paddingY"
						)}
    `}
					>
						<span
							style={{
								fontFamily: baseTheme.h2?.font || baseTheme.font?.family,
								color: checkForOverride(
									baseTheme,
									"social",
									cue.preset,
									"h2",
									"colour"
								),
								fontWeight:
									checkForOverride(
										baseTheme,
										"social",
										cue.preset,
										"h2",
										"bold"
									) === true
										? "bold"
										: "normal",
								fontStyle:
									checkForOverride(
										baseTheme,
										"social",
										cue.preset,
										"h2",
										"italic"
									) === true
										? "italic"
										: "normal",
								textDecoration:
									checkForOverride(
										baseTheme,
										"social",
										cue.preset,
										"h2",
										"underline"
									) === true
										? "underline"
										: "none",
							}}
							className={`${baseThemeId}_${
								cue.type
							}_small_text small_text  block whitespace-nowrap
  text-${checkForOverride(baseTheme, "social", cue.preset, "h2", "size")}
leading-${checkForOverride(baseTheme, "social", cue.preset, "h2", "leading")}
                    

`}
						>
							{cue.chat.authorDetails.isChatSponsor && (
								<span className="font-semibold pr-1 rounded uppercase ">
									{settings?.youtube_member_language || "Member"}
								</span>
							)}{" "}
							<ReplaceWithDataSource
								text={cue.chat?.authorDetails?.displayName}
							/>
						</span>
						<span
							style={{
								fontFamily: baseTheme.h1?.font || baseTheme.font?.family,
								color: checkForOverride(
									baseTheme,
									"social",
									cue.preset,
									"h1",
									"colour"
								),
								fontWeight:
									checkForOverride(
										baseTheme,
										"social",
										cue.preset,
										"h1",
										"bold"
									) === true
										? "bold"
										: "normal",
								fontStyle:
									checkForOverride(
										baseTheme,
										"social",
										cue.preset,
										"h1",
										"italic"
									) === true
										? "italic"
										: "normal",
								textDecoration:
									checkForOverride(
										baseTheme,
										"social",
										cue.preset,
										"h1",
										"underline"
									) === true
										? "underline"
										: "none",
							}}
							className={`${baseThemeId}_${cue.type}_large_text large_text
text-${checkForOverride(baseTheme, "social", cue.preset, "h1", "size")}
leading-${checkForOverride(baseTheme, "social", cue.preset, "h1", "leading")}
`}
						>
							<ReplaceWithDataSource
								text={cue.chat?.snippet?.displayMessage}
							/>
						</span>
					</span>
				</div>
			</div>
		</>
	);
}
